import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Divider, Grid } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { convertMillisToHMS, formatToLocalTime } from '../../utils/bookFormUtilities';
import { getBookTreeElement, selectFullBookTreeData } from '../../slices/storyEditorSlice';

import { AuthStdFooter } from "../../utils/auth-std-footer";
const ActiveStory = () => {
  const dispatch = useDispatch();
  const hasFullBook = useSelector(selectFullBookTreeData);

  const [hasBookStatistics, setHasBookStatistics] = useState({});
  const [hasUserStatistics, setHasUserStatistics] = useState({});
  const [hasBook, setHasBook] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const bookItem = await dispatch(getBookTreeElement('HAS_BOOK')).unwrap();
      setHasBook(bookItem);

      if (bookItem?.uuid) {
        const statistics = await dispatch(getBookTreeElement('HAS_BOOK_STATISTICS')).unwrap();
        setHasBookStatistics(statistics);

        const userStatistics = await dispatch(getBookTreeElement('HAS_USER_STATISTICS')).unwrap();
        setHasUserStatistics(userStatistics);
      }
    };

    fetchData();
  }, [dispatch, hasFullBook]);

  // useEffect(() => {
  //   if (!_.isEmpty(hasBook) && !_.isEmpty(hasBookStatistics) && !_.isEmpty(hasUserStatistics)) {
  //     if (onComplete) {
  //       onComplete({ hasBook, hasBookStatistics, hasUserStatistics });
  //     }
  //   }
  // }, [hasBook, hasBookStatistics, hasUserStatistics, onComplete]);

  const generateContent = () => {
    if (_.isEmpty(hasBook)) {
      return (
        <div style={{ marginBottom: "70px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          Please Select a Story...
        </div>
      );
    }

    const actDate = new Date(hasBook.updatedAt);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    };

    return (
      <div className="helperPopup">
        <dl>
          <dt>Story</dt>
          <dd>{hasBook.name}</dd>
          <dt>UpdatedAt</dt>
          <dd>{actDate.toLocaleDateString(undefined, options)}</dd>
          <dt>Story Uuid</dt>
          <dd>{hasBook.uuid}</dd>
        </dl>
        <Divider className='noMargNoPad' />
        <Grid style={{ width: "100%" }}>
          <Grid.Row className='noPadBottom'>
            <Grid.Column className='noPadRight' width={5}>Most Recent</Grid.Column>
            <Grid.Column className='noPadLeft noPadRight' textAlign="right" width={7}>
              {formatToLocalTime(hasBookStatistics?.mostRecentDateTime)}
            </Grid.Column>
            <Grid.Column className='noPadLeft noPadRight' textAlign='right' width={4}>
              {convertMillisToHMS(hasBookStatistics?.mostRecentProcTime || 0)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='noPadTop noPadBottom'>
            <Grid.Column width={10}>Total Time</Grid.Column>
            <Grid.Column className='noPadRight' textAlign='right' width={6}>
              {convertMillisToHMS(hasBookStatistics?.totalProcTime || 0)}
            </Grid.Column>
          </Grid.Row>
          <Divider className='noMarginBottom' />
          <Grid.Row className='noPadTop'>
            <Grid.Column width={10}>User Total Process Time</Grid.Column>
            <Grid.Column className='noPadRight' textAlign='right' width={6}>
              {convertMillisToHMS(hasUserStatistics?.totalProcTime || 0)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  };

  return generateContent();
};

export default ActiveStory;
